<template>
  <div>
    <v-toolbar flat>
      <v-col cols="2">
        <v-select
          v-model="program"
          :items="rsPrograms"
          :item-text="(item) => `${item.code} - ${item.name}`"
          item-value="programId"
          label="Program"
          dense
          hide-details
          clearable
        ></v-select>
      </v-col>
      <v-col cols="2">
        <v-select
          v-model="service"
          :items="rsServices"
          :item-text="(item) => `${item.code} - ${item.name}`"
          item-value="serviceId"
          label="Service"
          dense
          hide-details
          clearable
        ></v-select>
      </v-col>
      <v-col cols="2">
        <v-autocomplete
          v-model="client"
          :items="clientOptions"
          label="Client"
          dense
          hide-details
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col cols="2">
        <v-autocomplete
          v-model="school"
          :items="schoolOptions"
          label="School"
          dense
          hide-details
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col cols="2">
        <v-select
          v-model="status"
          :items="statusOptions"
          label="Status"
          dense
          hide-details
          clearable
        ></v-select>
      </v-col>
    </v-toolbar>
    <transmittals-table
      :loading="loading"
      :transmittals="filteredTransmittals"
      :search="search"
      :isProcessed="true"
    ></transmittals-table>
  </div>
</template>
<script>
import TransmittalsTable from "./transmittals-table.vue";
import { TransmittalStatus } from "../../objs/TransmittalStatus";
export default {
  components: {
    TransmittalsTable,
  },
  async mounted() {
    this.loading = true;
    this.$store.dispatch("transmittalsModule/clearTransmittals");
    await this.$store.dispatch("transmittalsModule/getAllPendingTransmittals");
    this.loading = false;
  },
  data() {
    return {
      loading: false,
      search: "",
      program: "",
      service: "",
      client: "",
      school: "",
      status: "",
      statusOptions: Object.values(TransmittalStatus),
    };
  },
  computed: {
    transmittals() {
      return this.$store.state.transmittalsModule.transmittals || [];
    },
    rsPrograms() {
      return this.$store.getters["optionsModule/getRelatedServicesPrograms"];
    },
    rsServices() {
      return this.$store.getters["optionsModule/getRSServices"];
    },
    clientOptions() {
      return this.transmittals
        .filter((item) => Boolean(item.clientName))
        .map((item) => {
          return {
            text: `${item.clientName} (${item.clientOSIS})`,
            value: item.clientName,
          };
        })
        .sort((a, b) => a.text.localeCompare(b.text));
    },
    schoolOptions() {
      return this.transmittals
        .filter((item) => Boolean(item.schoolName))
        .map((item) => {
          return {
            text: item.schoolName,
            value: item.schoolName,
          };
        })
        .sort((a, b) => a.text.localeCompare(b.text));
    },
    filteredTransmittals() {
      var list = [...this.transmittals];
      if (this.program) {
        list = list.filter((item) => item.programId == this.program);
      }
      if (this.service) {
        list = list.filter((item) => item.serviceId == this.service);
      }
      if (this.client) {
        list = list.filter((item) => item.clientName == this.client);
      }
      if (this.school) {
        list = list.filter((item) => item.schoolName == this.school);
      }
      if (this.status) {
        list = list.filter((item) => item.status == this.status);
      }
      return list;
    },
  },
};
</script>
